import { useState } from 'react'
import { X, Share2 } from 'lucide-react'
import type { PersonalList } from '../../types'

interface ShareListModalProps {
  list: PersonalList
  onClose: () => void
}

export default function ShareListModal({ list, onClose }: ShareListModalProps) {
  const [email, setEmail] = useState('')

  // List sharing has no backend endpoint yet: resource_lists/handler.py exposes
  // only create / delete / list / items — there is no share route. So the Share
  // action is a real disabled/pending state rather than a fabricated success
  // toast. When a share endpoint lands, wire it here and re-enable the button.
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-xl max-w-md w-full mx-4 p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">Share "{list.name}"</h3>
          <button onClick={onClose} className="p-1 text-gray-500 hover:text-gray-600">
            <X size={18} />
          </button>
        </div>

        <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg text-sm text-amber-800">
          Sharing lists by email isn't available yet — this feature is coming soon.
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 light-input text-sm outline-none"
              placeholder="collaborator@example.com"
            />
          </div>
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button onClick={onClose} className="px-4 py-2 text-sm text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50">
            Cancel
          </button>
          <button
            type="button"
            disabled
            title="List sharing is not yet available"
            aria-disabled="true"
            className="flex items-center gap-1.5 px-4 py-2 text-sm text-white bg-iflow-700 rounded-lg opacity-50 cursor-not-allowed"
          >
            <Share2 size={14} /> Share
          </button>
        </div>
      </div>
    </div>
  )
}
